import moment from "moment";
import DateTimeFormatter, {
  getNthDayOfMonth,
} from "../../../utils/DateFormatter";
import useLocalStorage from "../../../hooks/localStorage";
import { useAppContext } from "../../../AppContext/App.context";
const tzlookup = require("tz-lookup");
// const [appData, dispatch]: any = useAppContext();

const setLastTimeOfDayInDate = (dateString: string) => {
  const LastTimeOfDayInDate = moment(dateString)
    .set({
      hour: 23,
      minute: 59,
      second: 59,
    })
    .format("YYYY-MM-DD HH:mm:ss");
  console.log(LastTimeOfDayInDate);
  return LastTimeOfDayInDate;
};
//a simple date formatting function
function dateFormat(inputDate: any, format: any) {
  var loginData: any = localStorage.getItem("loginData");
  let dateTimeFormat = JSON.parse(loginData).datetime_format;

  let dateType = typeof inputDate;
  let date: any = "";
  //parse the input date
  if (
    dateTimeFormat == "DD-MM-YYYY HH:mm" ||
    dateTimeFormat == "DD-MM-YYYY hh:mm A"
  ) {
    if (dateType == "string") {
      const myArray = inputDate.split("-");
      const yearAndTimeArray = myArray[2].split(" ");
      inputDate =
        myArray[1] +
        "-" +
        myArray[0] +
        "-" +
        yearAndTimeArray[0] +
        " " +
        yearAndTimeArray[1];
    } else {
      date = new Date(inputDate);
    }
  }
  if (dateType == "string") {
    if (DateTimeFormatter.checkIfTimeInTz(inputDate)) {
      date = moment(inputDate).utc().format("YYYY-MM-DD");
      return date;
    } else {
      date = new Date(inputDate);
    }
  } else {
    date = new Date(inputDate);
  }
  //extract the parts of the date
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  //replace the month
  format = format.replace("MM", month.toString().padStart(2, "0"));

  //replace the year
  if (format.indexOf("yyyy") > -1) {
    format = format.replace("yyyy", year.toString());
  } else if (format.indexOf("yy") > -1) {
    format = format.replace("yy", year.toString().substr(2, 2));
  }

  //replace the day
  format = format.replace("dd", day.toString().padStart(2, "0"));

  return format;
}
const createJobService = {
  getRecurringBody(repeatData: any, isRecurringEdit: any) {
    const originalDateTimeFormat = DateTimeFormatter.getOriginalDateTimeFormat();
    if (DateTimeFormatter.isSpecialDateTimeFormat(repeatData.endDate)) {
      repeatData.endDate = DateTimeFormatter.convertDateStringIntoSpecificFormat(
        repeatData.endDate,
        originalDateTimeFormat,
        "YYYY-MM-DD HH:mm"
      );
    }
    repeatData.occurrences = repeatData.occurrences
      ? parseInt(repeatData.occurrences)
      : 0;
    repeatData.scheduleEndCriteria = repeatData.scheduleEndCriteria
      ? parseInt(repeatData.scheduleEndCriteria)
      : 0;
    let endOn: any = "";
    switch (parseInt(repeatData.cycle)) {
      case 0:
      case 7:
        if (repeatData.scheduleEndCriteria == 0) {
          endOn = dateFormat(repeatData.endDate, "yyyy-MM-dd");
          // endOn=DateTimeFormatter.convertDateTimeWithoutUTC(repeatData.endDate,"YYYY-MM-DD");
          // endOn = momconvertDateStringIntoSpecificFormatent(repeatData.endDate).format("YYYY-MM-DD");
        } else {
          let occurTime = repeatData.occurrences;
          if (repeatData.cycle === 7) {
            occurTime = occurTime + occurTime - 1;
          }
          endOn = moment(repeatData.startOn)
            .add(occurTime - 1, "days")
            .format("YYYY-MM-DD");
        }
        break;
      case 1:
        let i = 0;
        if (repeatData.scheduleEndCriteria === 0) {
          endOn = dateFormat(repeatData.endDate, "yyyy-MM-dd");
          // endOn = moment(repeatData.endDate).utc().format("YYYY-MM-DD");
        } else {
          const currentDay = moment(repeatData.startOn).format("d");
          let tempSelectedDays: any = [];
          for (let dayId in repeatData.cycle_def) {
            let obj: any = {
              dayId: dayId,
              isSelected: 1,
            };
            if (dayId < currentDay) {
              const dayDiff = parseInt(currentDay) - parseInt(dayId);
              obj.newEndDate = moment(repeatData.startOn)
                .subtract(dayDiff, "days")
                .format("YYYY-MM-DD");
            } else {
              const dayDiff = parseInt(dayId) - parseInt(currentDay);
              obj.newEndDate = moment(repeatData.startOn)
                .add(dayDiff, "days")
                .format("YYYY-MM-DD");
            }
            if (repeatData.cycle_def[dayId] === true) {
              tempSelectedDays.push(obj);
            }
          }
          let occurTime = repeatData.occurrences;
          for (let j = 0; j < tempSelectedDays.length; j++) {
            if (tempSelectedDays[j].dayId >= currentDay) {
              endOn = tempSelectedDays[j].newEndDate;
              tempSelectedDays[j].newEndDate = endOn;
              i++;
              if (i === occurTime) {
                break;
              }
            }
          }
          for (; i < occurTime; ) {
            for (let day = 0; day < tempSelectedDays.length; day++) {
              if (i < occurTime) {
                endOn = moment(tempSelectedDays[day].newEndDate)
                  .add(7, "days")
                  .format("YYYY-MM-DD");
                tempSelectedDays[day].newEndDate = endOn;
                i++;
              }
            }
          }
        }
        break;
      case 8:
        if (repeatData.scheduleEndCriteria === 0) {
          endOn = dateFormat(repeatData.endDate, "yyyy-MM-dd");
        } else {
          if (repeatData?.recurrence_pattern?.type === 2) {
            // Get start date and determine its week-of-month
            const startDate = moment(repeatData.pattern_date);
            const dayOfWeek = startDate.day(); // 0 = Sunday, 1 = Monday, etc.
            const weekOfMonth = Math.ceil(startDate.date() / 7); // e.g., 3 for 3rd Monday

            // Find the date of the last occurrence
            let currentMonth = startDate.month();
            let currentYear = startDate.year();
            let occurrencesFound = 1; // Count the start date as the first occurrence
            let lastDate = startDate;

            while (occurrencesFound < repeatData.occurrences) {
              // Move to the next month
              currentMonth += 1;
              if (currentMonth > 11) {
                currentMonth = 0;
                currentYear += 1;
              }

              const nextDate = getNthDayOfMonth(
                currentYear,
                currentMonth,
                weekOfMonth,
                dayOfWeek
              );
              if (nextDate) {
                occurrencesFound += 1;
                lastDate = nextDate;
              }
            }
            endOn = lastDate.format("YYYY-MM-DD");
          } else {
            // Handle specific day of month recurrence (e.g., 31st of each month)
            const startDate = moment(repeatData.pattern_date);
            const dayOfMonth = startDate.date(); // Get the day of the month (e.g., 31)
            let currentMonth = startDate.month();
            let currentYear = startDate.year();
            let occurrencesFound = 1; // Count the start date as first occurrence
            let lastDate = startDate;

            while (occurrencesFound < repeatData.occurrences) {
              // Move to the next month
              currentMonth += 1;
              if (currentMonth > 11) {
                currentMonth = 0;
                currentYear += 1;
              }

              // Determine the last day of the next month
              const nextMonthDate = moment([currentYear, currentMonth, 1]);
              const lastDayOfMonth = nextMonthDate.endOf("month").date(); // Get the last day of the month (e.g., 30, 28, or 29)

              // Use the desired day or the last day of the month if the desired day is too large
              const targetDay = Math.min(dayOfMonth, lastDayOfMonth);

              // Create date for the target day in the next month
              const nextDate = moment([currentYear, currentMonth, targetDay]);

              // Check if the date is valid
              if (nextDate.isValid()) {
                occurrencesFound += 1;
                lastDate = nextDate;
              }
            }
            endOn = lastDate.format("YYYY-MM-DD");
          }
        }
        break;
      case 9:
        if (repeatData.scheduleEndCriteria === 0) {
          endOn = dateFormat(repeatData.endDate, "yyyy-MM-dd");
        } else {
          if (repeatData?.recurrence_option?.type === 2) {
            // Parse the start date
            const startDate = moment(repeatData.pattern_date);
            const startMonth = startDate.month(); // Get the month (0-11)
            const startYear = startDate.year();
            const startWeekday = startDate.day(); // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)

            // Calculate which week of the month the start date falls in
            const startWeekOfMonth = Math.ceil(startDate.date() / 7); // E.g., third week if date is 15th

            // Calculate the target year based on occurrences
            const targetYear = startYear + (repeatData.occurrences - 1);

            // Set the target date to the first day of the same month in the target year
            let targetDate = moment({
              year: targetYear,
              month: startMonth,
              date: 1,
            });

            // Move to the first occurrence of the same weekday in the target month
            while (targetDate.day() !== startWeekday) {
              targetDate.add(1, "day");
            }

            // Move to the correct week of the month (e.g., third week)
            targetDate.add(startWeekOfMonth - 1, "weeks");

            endOn = targetDate.format("YYYY-MM-DD");
          } else {
            // Parse the start date
            const startDate = moment(repeatData.pattern_date);
            const startDay = startDate.date(); // Get the day of the month (e.g., 30)
            const startMonth = startDate.month(); // Get the month (0-11)
            const startYear = startDate.year();

            // Calculate the target year based on occurrences
            const targetYear = startYear + (repeatData.occurrences - 1);

            // Set the end date to the same day and month in the target year
            let targetDate = moment({
              year: targetYear,
              month: startMonth,
              date: startDay,
            });

            // Check if the date is valid (e.g., 30th Feb is invalid)
            if (!targetDate.isValid()) {
              // Adjust to the last day of the month if invalid
              targetDate = moment({
                year: targetYear,
                month: startMonth,
              }).endOf("month");
            }

            endOn = targetDate.format("YYYY-MM-DD");
          }
        }
        break;
      case 10:
        if (repeatData.scheduleEndCriteria === 0) {
          endOn = dateFormat(repeatData.endDate, "yyyy-MM-dd");
        } else {
          // Initialize variables
          let tempSelectedDays = [];
          let occurrenceDates = [];
          let tempTime = 0;
          const occurTime = repeatData.occurrences;
          const startDate = moment(repeatData?.startOn);
          const currentDay = parseInt(startDate.format("d"));

          // Step 1: Identify selected days from cycle_def
          for (let dayId in repeatData.cycle_def) {
            if (repeatData.cycle_def[dayId] === true) {
              const dayIdNum = parseInt(dayId);
              // Calculate the next or current occurrence of this day
              let dayDiff;
              if (dayIdNum === currentDay) {
                // Today is the selected day, use startDate
                dayDiff = 0;
              } else if (dayIdNum > currentDay) {
                // Selected day is later this week
                dayDiff = dayIdNum - currentDay;
              } else {
                // Selected day is next week
                dayDiff = 7 - (currentDay - dayIdNum);
              }
              let firstDate = moment(startDate)
                .add(dayDiff, "days")
                .format("YYYY-MM-DD");
              tempSelectedDays.push({
                dayId: dayIdNum,
                firstDate: firstDate,
              });
            }
          }

          // Sort by date to process in chronological order
          tempSelectedDays.sort((a, b) =>
            moment(a.firstDate).diff(moment(b.firstDate))
          );

          // Step 2: Generate fortnightly occurrences
          let cycleCount = 0; // Start with the first occurrence
          while (tempTime < occurTime) {
            for (
              let day = 0;
              day < tempSelectedDays.length && tempTime < occurTime;
              day++
            ) {
              let baseDate = moment(tempSelectedDays[day].firstDate);
              let nextDate = baseDate
                .add(14 * cycleCount, "days")
                .format("YYYY-MM-DD");
              occurrenceDates.push(nextDate);
              tempTime++;
            }
            cycleCount++;
          }

          // Step 3: Set endOn to the last occurrence
          if (occurrenceDates.length > 0) {
            occurrenceDates.sort((a, b) => moment(a).diff(moment(b))); // Ensure chronological order
            endOn = occurrenceDates[occurrenceDates.length - 1];
          } else {
            // Fallback to startDate if no valid dates are found
            endOn = moment().format("YYYY-MM-DD");
          }
        }
        break;
      case 5:
        if (repeatData.scheduleEndCriteria === 0) {
          endOn = dateFormat(repeatData.endDate, "yyyy-MM-dd");
        } else {
          endOn = moment(repeatData.startOn)
            .add((repeatData.occurrences - 1) * 3, "months")
            .format("YYYY-MM-DD");
        }
        break;
      case 6:
        if (repeatData.scheduleEndCriteria === 0) {
          endOn = dateFormat(repeatData.endDate, "yyyy-MM-dd");
        } else {
          endOn = moment(repeatData.startOn)
            .add((repeatData.occurrences - 1) * 6, "months")
            .format("YYYY-MM-DD");
        }
    }
    const differenceBetweenStartAndEndDate = moment(
      repeatData.lastEndDate
    ).diff(moment(repeatData.startOn), "days");
    endOn = setLastTimeOfDayInDate(endOn);
    let reqBody: any = {
      start_date: repeatData.startOn,
      name: repeatData.recurringName,
      end_date: endOn,
      cycle: repeatData.cycle,
      occurrences:
        repeatData.scheduleEndCriteria == 1
          ? parseInt(repeatData.occurrences)
          : 0,
      end_date_timezone: repeatData.last_date_timezone,
      start_date_timezone: repeatData.start_date_timezone,
    };
    if (isRecurringEdit) {
      reqBody["id"] = repeatData.id;
    }
    reqBody["last_task_date"] = setLastTimeOfDayInDate(
      moment(endOn)
        .add(differenceBetweenStartAndEndDate, "days")
        .format("YYYY-MM-DD")
    );
    if (repeatData.cycle === 1) {
      reqBody["cycle_def"] = repeatData.cycle_def;
    }

    return reqBody;
  },
  validateRecurringData(repeatData: any) {
    const validateEndDate = () => {
      if (!repeatData.endDate) {
        return "Please enter a valid end date for schedule";
      } else if (moment(repeatData.startOn).isAfter(repeatData.endDate)) {
        return "Repeat end date should be greater than task time";
      }
    };
    if (!repeatData.recurringName.trim()) {
      return "Please enter a valid schedule name";
    }
    if (repeatData.scheduleEndCriteria == 0) {
      return validateEndDate();
    } else {
      if (!repeatData.occurrences || repeatData.occurrences < 1) {
        return "Please enter a valid no of occurrences";
      }
    }
  },
  getStartAndEndTaskDateTimezone(taskDatesForSchedulingRule: any) {
    var min = taskDatesForSchedulingRule.reduce(function (a: any, b: any) {
      return a.local_datetime < b.local_datetime ? a : b;
    });
    var max = taskDatesForSchedulingRule.reduce(function (a: any, b: any) {
      return a.local_datetime > b.local_datetime ? a : b;
    });
    return {
      startOn: min.local_datetime,
      start_date_timezone: min.timezone,
      lastEndDate: max.local_datetime,
      last_date_timezone: max.timezone,
    };
  },
  getTimezoneForTask(taskDate: any, taskLocation: any, returnType?: string) {
    const lat = parseFloat(taskLocation.lat).toFixed(4);
    const lng = parseFloat(taskLocation.lng).toFixed(4);
    const timezoneString = tzlookup(lat, lng);
    if (returnType === "timezonestring") {
      return timezoneString;
    }
    let m = moment.utc(taskDate).tz(timezoneString);
    const offsetInMinutes = m.utcOffset();
    return offsetInMinutes;
  },
};
export default createJobService;
